import { render } from "./VProfessionalConsultations.vue?vue&type=template&id=ebbdc03a&scoped=true&ts=true"
import script from "./VProfessionalConsultations.vue?vue&type=script&lang=ts"
export * from "./VProfessionalConsultations.vue?vue&type=script&lang=ts"

import "./VProfessionalConsultations.vue?vue&type=style&index=0&id=ebbdc03a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebbdc03a"]])

export default __exports__